/**
 * ResponsiveRoute — renders mobile workspace for phone-like Cognito users
 * and desktop workspace for everyone else, at the SAME URLs.
 *
 * Detection uses real phone UA and coarse pointer; desktop at narrow
 * viewport does NOT flip to mobile.
 */
import React from 'react'
import { useMobileContext } from '../contexts/MobileContext'

interface ResponsiveRouteProps {
  mobile: React.ReactNode
  desktop: React.ReactNode
}

const ResponsiveRoute: React.FC<ResponsiveRouteProps> = ({ mobile, desktop }) => {
  const { isMobile } = useMobileContext()

  if (isMobile) {
    return <>{mobile}</>
  }

  return <>{desktop}</>
}

export default ResponsiveRoute
